import { IppicaLocale } from 'features/ippica/types';
import { IppicaQuoteFinaliBox } from '../ippicaQuote/ippicaQuoteFinaliBox';
import { convertAmountWithoutCurrencyValue } from 'utility/functions';
import styles from './IppicaQuoteFinaliResultsContainer.module.scss';
import useWindowSize from 'hooks/useWindowSize';

export type QuoteFinaliResultsContainerProps = {
  title: string;
  esitoList: Array<any>;
};
export const IppicaQuoteFinaliResultsContainer = ({ title, esitoList }: QuoteFinaliResultsContainerProps) => {
  const { isMobile } = useWindowSize();

  return (
    !!esitoList?.length && (
      <IppicaQuoteFinaliBox
        title={title}
        esitoList={esitoList?.map((d) => ({
          esito: d.combinazione,
          quota: convertAmountWithoutCurrencyValue(+d.quota, IppicaLocale.it),
        }))}
        containerClassName={styles.quota100}
        hasMarginBottom={isMobile}
      />
    )
  );
};
